import { isMobile } from 'react-device-detect';
import ARQR from './ARQR';
import { IGame } from '@/interface/game';

type ARMobileViewWrapperProps = {
  children: any;
  gameId: string;
  game: IGame;
  customDomain?: string;
};
const ARMobileViewWrapper = ({
  children,
  gameId,
  game,
  customDomain,
}: ARMobileViewWrapperProps) => {
  if (!isMobile)
    return <ARQR gameId={gameId} game={game} customDomain={customDomain} />;

  return <>{children}</>;
};

export default ARMobileViewWrapper;
